import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'ui';

export const Buttons = styled(Flex)`
  float: right;
  > :first-child {
    margin-right: 5px;
  }
  justify-content: flex-end;
  margin-top: 15px;
`;

export const StyledNotificationButton = styled(Button)`
  text-transform: uppercase;
  border: 2px solid #6f7e95 !important;
  color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
  background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  &:hover {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
    opacity: 0.7 !important;
  }
  &:focus {
    border: 2px solid #6f7e95 !important;
    color: ${p => p.primary ? 'white' : '#6f7e95'} !important;
    background-color: ${p => p.primary ? '#6f7e95' : 'white'} !important;
  }
  &:disabled {
    opacity: 0.7;
  }
  ${p => p.marginTop && `margin-top: ${p.marginTop}px`};
`;

const WarningNotification = ({
  onConfirm,
  onClose,
  isLoading = false,
  confirmButtonText,
  closeButtonText,
  confirmDisabled = false,
  body,
}) =>
  <>
    {body}
    <Buttons>
      {onClose ?
        <StyledNotificationButton
          onClick={onClose}
          disabled={isLoading}
          data-test-id='btn-popup-close'
        >
          {closeButtonText}
        </StyledNotificationButton> :
        null
      }

      <StyledNotificationButton
        primary={1}
        onClick={onConfirm}
        disabled={confirmDisabled || isLoading}
        loading={isLoading}
        data-test-id='btn-popup-confirm'
      >
        {confirmButtonText}
      </StyledNotificationButton>
    </Buttons>
  </>;

WarningNotification.propTypes = {
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  isLoading: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  closeButtonText: PropTypes.string,
  body: PropTypes.object,
  confirmDisabled: PropTypes.bool,
};

export default WarningNotification;
